/* Emir ICE — bloc de lancement du Studio IA : phrase qui se tape, puis l'image apparaît.
   Facultatif : sans ce fichier (ou sans JavaScript, ou avec « moins de mouvement »), la phrase complète et l'image sont affichées tout de suite.
   La place du texte et de l'image est réservée par le CSS : aucun saut de page. InstantClick remplace le <body> : boot() est rappelé à chaque page. */
(function () {
  'use strict';
  if (window.__eixSL) { window.__eixSL.boot(); return; }
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function lancer(root) {
    if (root.__eixSLok) return; root.__eixSLok = true;
    if (!root.hasAttribute('data-anim') || (RM && RM.matches)) return;
    var ghost = root.querySelector('.eix-sl__ghost'); var typed = root.querySelector('.eix-sl__typed'); var img = root.querySelector('.eix-sl__img');
    if (!ghost || !typed || !img) return;
    var texte = ghost.textContent || '';
    if (!texte) return;
    root.classList.add('is-anim');
    var fini = false;
    var terminer = function () { if (fini) return; fini = true; typed.textContent = texte; root.classList.add('is-done'); };
    var depart = function () {
      var i = 0; var pas = Math.max(16, Math.min(46, Math.round(2400 / texte.length)));
      var t = setInterval(function () {
        if (!document.body.contains(root)) { clearInterval(t); return; }
        i += 1; typed.textContent = texte.slice(0, i);
        if (i >= texte.length) { clearInterval(t); setTimeout(terminer, 260); }
      }, pas);
    };
    /* filet de sécurité : quoi qu'il arrive, l'image est visible au bout de 6 s */
    setTimeout(terminer, 6000);
    var go = function () { setTimeout(depart, 380); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0] && es[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: 0.2 });
      io.observe(root);
    } else go();
  }
  function boot() {
    var l = document.querySelectorAll('[data-eix-sl]');
    for (var i = 0; i < l.length; i++) lancer(l[i]);
  }
  window.__eixSL = { boot: boot };
  function demarrer() {
    boot();
    if (window.InstantClick && typeof window.InstantClick.on === 'function') window.InstantClick.on('change', boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
